export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -03.3ba85fd4.png";